// TalentExit — bilingual user-facing error translation (TE-UAT-02).
// Known backend detail codes map to friendly ES/EN messages; anything else
// falls back to the platform formatter. Raw codes stay in logs only.
import { formatApiError } from '@/lib/api';

const KNOWN = new Set([
  'employee_account_inactive', 'employee_account_missing',
  'open_exit_case_exists', 'interview_already_resolved',
  'case_closed', 'case_already_closed', 'case_not_closed',
  'talentexit_not_authorized', 'talentexit_raw_confidential', 'retention_expired',
  'not_applicable_requires_note', 'interview_not_resolved',
  'exit_interview_instrument_unavailable', 'employee_not_found',
  'exit_case_not_found', 'invalid_exit_type', 'invalid_reason_category', 'invalid_evidence_url', 'invalid_format',
]);

export function txError(t, e) {
  const d = e?.response?.data?.detail;
  if (typeof d === 'string' && KNOWN.has(d)) {
    return t(`talentexit.errors.${d}`);
  }
  return formatApiError(e);
}
